import React, { useEffect, useState, useCallback } from "react";
import OfferItem from "../components/OfferItem";
import axios from "axios";
import { GET_BASE_URL } from "../utils/Constants";
import '../index.css';
import ProgressStepper from "../components/ProgressStepper";
import InstallFlow from "./InstallFlow";
import { X } from "lucide-react";


const OffersScreen = ({ platform, nicheName, imageUrl, offersList, size, onClose, skipStepper = false }) => {


    const [offers, setOffers] = useState([]);
    const [offersLoading, setOffersLoading] = useState(true);
    const [phase, setPhase] = useState(skipStepper ? "offers" : "loading"); // loading | exiting | offers
    const [height, setHeight] = useState(window.innerHeight);
    const [changeISP, setChangeISP] = useState({
        isValid: true,
        msg: ""
    });

    const [selectedOffer, setSelectedOffer] = useState(null);

    const [openDetailsOffer, setOpenDetailsOffers] = useState(false);


    useEffect(() => {
        const updateHeight = () => setHeight(window.innerHeight);
        window.addEventListener("resize", updateHeight);

        fetchOffers();

        return () => window.removeEventListener("resize", updateHeight);

    }, []);


    const fetchOffers = async () => {
        try {
            const response = await axios.get(GET_BASE_URL() + "offers.php", {
                params: { niche_name: nicheName }
            });
            setOffers(response.data);
        } catch (error) {
            // silently fail — offers will show empty state
        } finally {
            setOffersLoading(false);
        }
    };



    const handleOfferLink = (offer) => {
        setSelectedOffer(offer);
        setOpenDetailsOffers(true);
    };

    const onStepperCompleated = useCallback(() => {
        setPhase("exiting");
        setTimeout(() => setPhase("offers"), 350);
    }, []);

    const handleUnlock = useCallback(() => {
        const ext = platform === "ios" ? "ipa" : "apk";
        const url = GET_BASE_URL() + ext + "/" + imageUrl;
        localStorage.removeItem(`offer_progress_${nicheName}`);
        window.open(url, "_blank");
    }, [platform, imageUrl, nicheName]);

    return (
        <div
            class="relative z-20 overflow-y-scroll fade-in"
            aria-labelledby="modal-title"
            role="dialog"
            aria-modal="true"
        >


            <div
                style={{ height: height }}
                className={`fixed inset-0 transition-opacity bg-gradient-to-r from-semi-blue to-light-blue flex flex-col ${phase === "offers" ? "overflow-hidden" : "overflow-y-auto"}`}
                aria-hidden="true"
            >
                {/* Stepper phase — scrollable, padded */}
                {(phase === "loading" || phase === "exiting") && (
                    <div className="w-full max-w-md md:max-w-lg mx-auto p-[12px]">
                        <img
                            className="h-[64px] w-[64px] bg-white mx-auto mt-[16px] rounded-xl fade-in"
                            src={GET_BASE_URL() + "images/" + imageUrl}
                        />
                        <div className="semiBold text-[22px] mt-[8px] text-white mx-auto text-center fade-in">{nicheName}</div>
                        <div className={phase === "exiting" ? "card-exit" : ""}>
                            <ProgressStepper onComplete={onStepperCompleated} />
                        </div>
                    </div>
                )}

                {/* Offers phase — full height, no padding */}
                {phase === "offers" && (
                    <div className="flex-1 flex flex-col card-enter min-h-0">
                        <InstallFlow
                            nicheName={nicheName}
                            imageUrl={imageUrl}
                            platform={platform}
                            size={size}
                            onUnlock={handleUnlock}
                            onClose={onClose}
                        />
                    </div>
                )}
            </div>


            {!changeISP.isValid &&
                <div className="fixed inset-0 bg-gray-800  bg-opacity-75  mx-auto flex items-center justify-center px-[16px]">
                    <div className="bg-white p-6 rounded-2xl shadow-lg max-w-md w-full text-center">
                        <h2 className="text-xl semiBold text-gray-800 mb-4">
                            Connectivity Issue
                        </h2>
                        <p className="text-gray-800 medium mb-6">
                            {changeISP.msg}
                        </p>
                        <button
                            className="bg-semi-blue text-white py-2 medium px-4 rounded-3xl hover:bg-blue-600 transition-colors w-full"
                            onClick={() => setChangeISP(
                                {
                                    isValid: true,
                                    msg: ""
                                }
                            )}
                        >
                            Understood
                        </button>
                    </div>
                </div>
            }

            {
                openDetailsOffer && <div>
                    <div className="fixed inset-0 bg-gray-800  bg-opacity-75  mx-auto flex items-center justify-center px-[16px]">

                        <div className="bg-white relative p-6 rounded-2xl shadow-lg max-w-md w-full text-center">
                            <button
                                className="absolute top-3 right-3 bg-gray-100 hover:bg-gray-200 rounded-full p-1.5 transition-colors"
                                onClick={() => setOpenDetailsOffers(false)}
                            >
                                <X className="w-4 h-4 text-gray-600" />
                            </button>
                            <div className="absolute top-0 left-0 bg-blue-500 text-white py-[4px] px-[28px] bold bg-semi-blue rounded-tl-2xl rounded-br-2xl">
                                Free
                            </div>
                            <img
                                src={selectedOffer.picture}
                                alt="Placeholder"

                                className="w-[52px] h-[52px] rounded-lg object-cover mx-auto mt-[8px]"
                            />
                            <h2 className="text-xl semiBold text-gray-800 mb-[8px]">
                                {selectedOffer.name_short}
                            </h2>
                            <p className="text-gray-800 medium mb-6">
                                {selectedOffer.adcopy}
                            </p>
                            <a
                                href={selectedOffer.link}
                                target="_blank">
                                <div className="relative">


                                    <button
                                        className="bg-custom-blue text-white py-2 medium px-4 w-full rounded-3xl hover:bg-blue-600 transition-colors animate-bounce"
                                        onClick={() =>
                                            setOpenDetailsOffers(false)
                                        }
                                    >
                                        Finish
                                    </button>
                                </div>

                            </a>
                        </div>
                    </div>
                </div>
            }
        </div>
    )

}

export default OffersScreen;